export const STRIPE_INVALID_ADDRESS = 'STRIPE_INVALID_ADDRESS';
export const CC_INVALID_ADDRESS = 'CC_VERIFICATION_INVALID_ADDRESS';
